//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/popup'
import 'devextreme/ui/scroll_view'
import 'devextreme/ui/toolbar'

//#endregion

import { EventsNames } from '../../../helpers/events-names'
import { i18n } from '../i18n/common.i18n'

//#region Asset Imports

import './confirmation-popup.scss'
import * as TEMPLATE from './confirmation-popup.tpl.html'

//#endregion

// Options

export type ConfirmationOptions = {
    title: string,
    question: string,

    onConfirmed?: () => void,
    onDeclined?: () => void
}

// Options End


interface ConfirmationScope extends ng.IScope {
    popupOptions: DevExpress.ui.dxPopupOptions
    toolbarOptions: DevExpress.ui.dxToolbarOptions

    id: number
    popupVisible: boolean
    title: string
    confirm: () => void
    confirmQuestion: string[]
    yes: string
    no: string
    confirmNo: () => void

    source: ConfirmationSource
}

export interface ConfirmationSource {
    confirmYes?: () => void
    confirmNo?: () => void
}

export class ConfirmationDirective implements ng.IDirective {
    private previousClickNr: number
    private clickNr: number = 0

    private confirm: any
    private confirmNo: any

    constructor() {

    }

    scope = {

        id: "=",
        confirm: '=?',
        confirmNo: '=',
        title: '@title',
        yes: '@yes',
        no: '@no',
        source: '=?',
    }

    restrict = 'E'
    controller = ['$scope', '$rootScope', ($scope: ConfirmationScope, $rootScope: ng.IRootScopeService) => {
        $scope.popupVisible = false

        $scope.popupOptions = {
            maxWidth: 400,
            height: 200,
            bindingOptions: {
                visible: 'popupVisible',
                title: 'title'
            },
            onShowing: () => {
                this.clickNr = this.clickNr + 1
            },
            showCloseButton: false
        }

        $scope.toolbarOptions = {
            items: [
                {
                    widget: 'dxButton',
                    options: {
                        text: $scope.yes ? $scope.yes : i18n('Common', 'Yes'),
                        onClick: () => {
                            if (this.previousClickNr !== this.clickNr) {
                                this.previousClickNr = this.clickNr
                                $scope.popupVisible = false

                                if (this.confirm) {
                                    this.confirm()
                                }

                                if ($scope.confirm)
                                    $scope.confirm()
                                if ($scope.source && $scope.source.confirmYes) {
                                    this.previousClickNr--
                                    $scope.source.confirmYes()
                                    $rootScope.$broadcast(EventsNames.CLOSE_CONFIRMATION_POPUP, null)
                                }
                            }
                        }
                    }
                },
                {
                    widget: 'dxButton',
                    options: {
                        text: $scope.no ? $scope.no : i18n('Common', 'No'),
                        onClick: () => {
                            this.previousClickNr = this.clickNr
                            $scope.popupVisible = false

                            if (this.confirmNo) {
                                this.confirmNo()
                            }

                            if ($scope.confirmNo)
                                $scope.confirmNo()
                            if ($scope.source && $scope.source.confirmNo) {
                                this.previousClickNr--
                                $scope.source.confirmNo()
                            }
                            $rootScope.$broadcast(EventsNames.CLOSE_CONFIRMATION_POPUP, null)
                        }
                    }
                }
            ]
        }

        $scope.$on(EventsNames.OPEN_CONFIRMATION_POPUP + $scope.id, (event: ng.IAngularEvent, ...args: any[]) => {
            if (typeof args[0] === 'object') {
                const options: ConfirmationOptions = args[0]

                this.confirm = options.onConfirmed
                this.confirmNo = options.onDeclined
                $scope.confirmQuestion = [options.question]
                $scope.title = options.title
            } else {
                $scope.confirmQuestion = [(args && args[0]) ? args[0] : i18n('Popup', 'ConfirmDeleteLocation')]
            }

            $scope.popupVisible = true
        })
    }]
    template = TEMPLATE
}